<div id="view-document" [hidden]="!isCheckAccessToContract || checkStatusProgress" style="overflow: hidden" >
  <div class="row">
    <div [ngClass]="{ 'col-lg-5 ': !isFullviewPdf }" [hidden]="isFullviewPdf" class="col-md-12 col-sm-12 pr-0">
      <div #focus tabindex="-1" class="card mat-card-content-contract-sm" style="
          height: calc(100vh - 140px);
          overflow-y: scroll;
          border-radius: unset !important;
          padding-bottom: 50px;
        ">
        <app-panel-document-view [documentTypeEnterprise]="documentTypeEnterprise" (navigate)="onBackClick()" [isDocumentMoha]="true" [forceShowCustomerSignInfo]="true">
        </app-panel-document-view>
        <div *ngIf="listApproverSignAcount.length > 0">
          <mat-expansion-panel  [expanded]="true" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title class="mat-panel-title class panel-title">
                {{ "approved.info_approved" | translate }}
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div>
              <mat-label>{{ "file_sign" | translate }}
              </mat-label>
              <mat-form-field class="w-100">

                <mat-select (selectionChange)="changeFileAddSign($event,'selectFileSign')"
                            [(ngModel)]="selectedFileSign">
                  <mat-option *ngFor="let file of fileUploads;let i = index" [value]="i">
                    {{ file.fileName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <nz-table #expandTable nzTableLayout="fixed" [nzFrontPagination]="false" [nzShowPagination]="false" class="ant-table-no-placeholder-border-bottom table-user-sign" nzBordered >
              <thead>
              <tr>
                <th class="text-center" nzWidth="10%">
                  {{ "enterprise_contract.panel_document.table_users.header.order_sign" | translate }}
                </th>
                <th class="text-center" nzWidth="40%">
                  {{ "enterprise_contract.panel_document.table_users.header.name" | translate }}
                </th>
                <!--                <th class="text-center" nzWidth="25%">-->
                <!--                  {{ "enterprise_contract.panel_document.table_users.header.role" | translate }}-->
                <!--                </th>-->
                <th class="text-center" nzWidth="10%" *ngIf="checkCTSShowImage.length > 0 && checkShowImage ">
                  {{ "enterprise_contract.panel_document.table_users.header.page" | translate }}
                </th>
                <th class="text-center" nzWidth="15%"  *ngIf="checkCTSShowImage.length > 0 && checkShowImage ">
                  {{ "enterprise_contract.panel_document.table_users.header.action" | translate }}
                </th>
              </tr>
              </thead>
              <tbody>
              <!-- nguoi dung phe duyet ben lap -->
              <ng-container *ngFor="let data of listApproverSignAcount; let i = index">
                <tr>
                  <td class="text-center">1</td>
                  <td>
                    {{ data.fullName }}
                  </td>
                  <!--                  <td class="text-center">-->
                  <!--                    {{'search_form.approve_doc' | translate}}-->
                  <!--                  </td>-->
                  <td  *ngIf="checkCTSShowImage.length > 0 && checkShowImage "></td>
                  <td class="text-center" *ngIf="data.CTS && data.showImage">
                    <button (click)="addSign(data)" color="primary" mat-icon-button
                            type="button">
                      <mat-icon class="mr-0" matTooltip="{{
                          'enterprise_contract.tooltips.add_sign' | translate
                        }}">add_circle
                      </mat-icon>
                    </button>
                  </td>
                  <td *ngIf="(!data.CTS || !data.showImage) && checkCTSShowImage.length > 0 && checkShowImage"  ></td>
                </tr>
                <ng-container *ngFor="let sign of listSignNew; let id = index">
                  <tr *ngIf="sign.userId == data.userId && checkHaveSign(data, sign)">
                    <td></td>
                    <td > {{ "signature_number" | translate }} {{sign.row_number}}</td>
                    <td class="text-center">{{sign.pageIndex}}</td>
                    <td class="text-center">
                      <button (click)="goToPage(data.enterpriseId, data.userId, sign)"
                              color="primary" mat-icon-button type="button">
                        <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.go_to_sign' | translate
                          }}">double_arrow
                        </mat-icon>
                      </button>
                      <!-- <button (click)="deleteSign(data.enterpriseId, data.userId, sign.idNumber)" *ngIf="checkHaveSign(data, sign.idNumber)" -->
                      <button (click)="deleteSign(data.enterpriseId, data.userId, (sign.contractSignId || sign.idNumber))"
                              color="primary" mat-icon-button type="button">
                        <mat-icon class="mr-0" matTooltip="{{
                            'enterprise_contract.tooltips.delete_sign' | translate
                          }}">close
                        </mat-icon>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              </tbody>
            </nz-table>
          </mat-expansion-panel>

        </div>
        <!--        <app-panel-setup-sign-flow-receive [documentInfo]="document" *ngIf="isSetupSignFlow" ></app-panel-setup-sign-flow-receive>-->
      </div>
    </div>
    <div [ngClass]="{ 'col-lg-7 ': !isFullviewPdf, 'col-lg-12': isFullviewPdf }" class="col-md-12 col-sm-12 view-pdf"
         [class.pl-0]="!isFullviewPdf" [class.mobile-hidden]="!isFullviewPdf" style="padding-right: 0.75rem">
      <div class="mat-elevation-z0 border-bottom" #headerControll [ngStyle]="{
          background:
            document.typeId === 1 &&
            document.mainContractAttachments &&
            document.mainContractAttachments.length
              ? 'linear-gradient(180deg, #fff 70%, #a6a6a6 30%)'
              : '#fff'
        }">
        <div class="d-flex justify-content-between">
          <div class="py-2 px-3 bg-white d-flex desktop" [ngStyle]="{
              'border-bottom-right-radius':
                document.typeId === 1 && activeFile === 0 ? '5px' : '0'
            }" id="box-left">
            <button class="mr-2 ml-2" *ngIf="permissionContractShare" color="primary" mat-icon-button (click)="tongleFullviewPdf()">
              <mat-icon [hidden]="isFullviewPdf" class="fullview-icon" matTooltip="{{
                  'enterprise_contract.tooltips.btn_expand_more' | translate
                }}">
                arrow_back_ios
              </mat-icon>
              <mat-icon [hidden]="!isFullviewPdf" class="fullview-icon" matTooltip="{{
                  'enterprise_contract.tooltips.btn_expand_less' | translate
                }}">
                arrow_forward_ios
              </mat-icon>
            </button>
          </div>
          <div class="d-flex" id="box-center" style="width: 10%" *ngIf="document.typeId === 1 || document.typeId === 0 || document.typeId === 2">
            <div style="width: 100%; position: relative; height: 52px">
              <div class="d-flex box-tab" style="
                  position: absolute;
                  width: 100%;
                  top: 0.5rem;
                  left: 0;
                  height: calc(52px - 0.5rem);
                ">
                <div class="px-2 py-2 tab" *ngFor="
                    let file of document.mainContractAttachments;
                    let i = index
                  " [class.active]="i === activeFile" [class.left]="i === activeFile - 1"
                     [class.right]="i === activeFile + 1" (click)="changeFile(file.path, i)"
                     [class.border-right]="i !== document.mainContractAttachments.length - 1 && i !== activeFile && i !== activeFile - 1"
                     [matTooltip]="file.fileName">

                  <div class="name">
                    <i nz-icon [nzType]="'loading'" *ngIf="file.loading"></i>
                    {{ file.fileName }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="px-3 py-2 bg-white" style="
              display: flex;
              justify-content: flex-end;
              align-items: center;
            " [ngStyle]="{
              'border-bottom-left-radius':
                document.typeId === 1 &&
                activeFile === document.mainContractAttachments.length - 1
                  ? '5px'
                  : '0'
            }" id="box-right">
            <button (click)="doPrint()" mat-stroked-button class="mr-2 btn-download-file-sm desktop" color="primary" appTrackEvent="w.btn.xem_chi_tiet_hd.in">
              <mat-icon class="mr-0">print</mat-icon>
              {{ "enterprise_contract.buttons.print" | translate }}
            </button>

            <button mat-stroked-button class="btn-download-file-sm desktop" color="primary" appTrackEvent="w.btn.xem_chi_tiet_hd.tai"
                    (click)="openPDFByBrowser(document.id)">
              <mat-icon class="mr-0">save_alt</mat-icon>
              {{ "enterprise_contract.buttons.download" | translate }}
            </button>
            <!-- <button class="ml-2 btn-copy-file-sm desktop" mat-stroked-button color="primary" appTrackEvent="w.btn.xem_chi_tiet_hd.sao_chep" *ngIf="
                    checkPermissionCreateContract() && !(document.formType === 'CONTRACT_APPENDIX') && !isOnlyView && checkUserType()" (click)="copyDocument(document.id)"
                    [disabled]="commonService.getIsLockedEnterprise()">
              <mat-icon class="mr-0">file_copy</mat-icon>
              {{ "enterprise_contract.buttons.copy" | translate }}
            </button> -->
            <button mat-icon-button class="btn-download-file-sm mobile" color="primary" appTrackEvent="w.btn.xem_chi_tiet_hd.tai"
                    (click)="openPDFByBrowser(document.id)">
              <mat-icon class="mr-0">save_alt</mat-icon>
            </button>
          </div>

          <!-- <div class="col-12 col-sm-3 pr-075"
            [matTooltip]="documentParentName ? document.name + ' - ' + documentParentName : document.name">
            <strong> {{document.name}} </strong>
            <strong *ngIf="document.parentId"> - {{documentParentName}} </strong>
          </div>
          <div class="col-12 col-sm-9 text-right pr-075">
            <button mat-stroked-button color="primary" (click)="openPDFByBrowser(document.id)">
              <mat-icon class="mr-0">save_alt</mat-icon>
              {{'enterprise_contract.buttons.download' | translate}}
            </button>
            <button class="ml-3" mat-stroked-button color="primary"
              *ngIf="document.typeId == documentForm && takeInfo == null && !document.isDifferentEnterprise && !warningContractQuantity && !deviceService.isMobile()"
              (click)="copyDocument(document.id)">
              <mat-icon class="mr-0">file_copy</mat-icon>
              {{'enterprise_contract.buttons.copy' | translate}}
            </button>
          </div> -->
        </div>
      </div>

      <div class="parent-document" style="display: flex; justify-content: space-between"
           [class.landscape]="isViewLandscape">
        <!-- <div id="preview" class="preview-main scrollbar" *ngIf="document.typeId === documentUpload || document.status !== EnumContractStatus.DRAFT"> -->
        <!--        <div id="preview" class="preview-main scrollbar">-->
        <!--          <div class="thumbnailpage {{item.isActive ? 'highlight' : ''}}" *ngFor="let item of thumbnail"-->
        <!--            id="page{{item.page}}" (click)="onClickThumbnailpage(item.page)">-->
        <!--            <img src="{{item.url}}" style="width: 100%">-->
        <!--            <span class="pagenumber" style="display: none;">{{item.page}}</span>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="document scrollbar_scontract_xs" #navigation id="navigation" tabindex="0" *ngIf="!checkStatusProgress"
             style="height: calc(100vh - 195px); width: 100%">
          <div>
            <ng-container>
              <ng-container *ngIf="pdfSrc && !isShowReferencePdf && checkTabPDF && signTextLayer">
                <ngx-extended-pdf-viewer [src]="pdfSrc" [(page)]="pageCurrent"
                                         (textLayerRendered)="textLayerRendered($event)" [(zoom)]="zoomLevel" useBrowserLocale="true"
                                         height="80vh" [showPrintButton]="false" [enablePrint]="true" [showDownloadButton]="false" [sidebarVisible]="true"
                                         [showRotateButton]="false" [showOpenFileButton]="false" [showBookmarkButton]="false"
                                         [showPropertiesButton]="false" [showUnverifiedSignatures]="true" [theme]="'dark'"
                                         [language]="language" [showSecondaryToolbarButton]="false" [showSidebarButton]="isShowSidebarButton"
                                         [textLayer]="true" [httpHeaders]="authorization">
                </ngx-extended-pdf-viewer>
              </ng-container>
              <ng-container *ngIf="pdfSrc && !isShowReferencePdf && checkTabPDF && !signTextLayer ">
                <ngx-extended-pdf-viewer [src]="pdfSrc" [(page)]="pageCurrent"
                                         (textLayerRendered)="textLayerRendered($event)" [(zoom)]="zoomLevel" useBrowserLocale="true"
                                         height="80vh" [showPrintButton]="false" [enablePrint]="true" [showDownloadButton]="false" [sidebarVisible]="true"
                                         [showRotateButton]="false" [showOpenFileButton]="false" [showBookmarkButton]="false"
                                         [showPropertiesButton]="false" [showUnverifiedSignatures]="true" [theme]="'dark'"
                                         [language]="language" [showSecondaryToolbarButton]="false" [showSidebarButton]="isShowSidebarButton"
                                         [textLayer]="true" [httpHeaders]="authorization">
                </ngx-extended-pdf-viewer>
              </ng-container>
              <ng-container *ngIf="pdfSrc && !isShowReferencePdf && !checkTabPDF && !document.isApproved && !loadSign">
                <ngx-extended-pdf-viewer (currentZoomFactor)="onChangeZoom($event)" (pagesLoaded)="onPagesLoaded($event)"
                                         (textLayerRendered)="textLayerRenderedNew($event)" [(page)]="pageIndex" [enablePrint]="false"
                                         [handTool]="false" [language]="language" [showBookmarkButton]="false" [showDownloadButton]="false"
                                         [showOpenFileButton]="false" [showPropertiesButton]="true" [showRotateButton]="false"
                                         [showSecondaryToolbarButton]="false" [showUnverifiedSignatures]="true" [sidebarVisible]="true"
                                         [src]="pdfSrc" [textLayer]="true" [theme]="'dark'" [zoomLevels]="[0.5, 1, 1.25, 1.5, 2, 3, 4]"
                                         class="pdf-viewer" height="80vh" style="display: block" useBrowserLocale="true"
                >
                </ngx-extended-pdf-viewer>
              </ng-container>
              <ng-container *ngIf="pdfSrc && !isShowReferencePdf && !checkTabPDF && !document.isApproved && loadSign">
                <ngx-extended-pdf-viewer (currentZoomFactor)="onChangeZoom($event)" (pagesLoaded)="onPagesLoaded($event)"
                                         (textLayerRendered)="textLayerRenderedNew($event)" [(page)]="pageIndex" [enablePrint]="false"
                                         [handTool]="false" [language]="language" [showBookmarkButton]="false" [showDownloadButton]="false"
                                         [showOpenFileButton]="false" [showPropertiesButton]="true" [showRotateButton]="false"
                                         [showSecondaryToolbarButton]="false" [showUnverifiedSignatures]="true" [sidebarVisible]="true"
                                         [src]="pdfSrc" [textLayer]="true" [theme]="'dark'" [zoomLevels]="[0.5, 1, 1.25, 1.5, 2, 3, 4]"
                                         class="pdf-viewer" height="80vh" style="display: block" useBrowserLocale="true"
                >
                </ngx-extended-pdf-viewer>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
      <hr style="margin: 0" />
    </div>

    <div class="scontract-btn-dsk bg-white text-center mat-elevation-z0 py-2 w-100" >
      <button mat-stroked-button color="primary" class="btn mr-3" type="button" *ngIf="checkEdit" (click)="onBackClick()" appTrackEvent="w.btn.xem_chi_tiet_hd.quay_lai">
        <mat-icon class="mr-0">arrow_back</mat-icon>
        {{ "form.back" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="mr-3" *ngIf="!checkEdit" (click)="cancel()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
      </button>
      <!-- <button mat-stroked-button color="primary" class="btn mr-3" *ngIf="!document.isApproved && checkEdit" type="button" (click)="onAddApproverClick()">
        <mat-icon class="mr-0">add_circle_outline</mat-icon>
        {{ "button.add_approver" | translate }}
      </button> -->
      <button mat-stroked-button color="primary" class="btn mr-3" *ngIf="!document.isApproved && !checkEdit" type="button" (click)="onAddApproverClick(1)">
        <mat-icon class="mr-0">add_circle_outline</mat-icon>
        {{ "form.btn_CSTL" | translate }}
      </button>
      <button mat-raised-button color="primary" class="btn mr-3" *ngIf="!document.isApproved && !checkEdit" type="button" (click)="submitSign()">
        {{ "form.btn_xacnhan" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="btn mr-3" *ngIf="!document.isForwarded && !this.isSetUpSignFlow" type="button" (click)="onForwardSignClick()">
        <mat-icon class="mr-0">send</mat-icon>
        {{ "title.forward_sign" | translate }}
      </button>
      <button mat-stroked-button color="primary" *ngIf="
          isStartSignFlow &&
          mediaBreakpoint !== SCREEN_SIZE.XS &&
          mediaBreakpoint !== SCREEN_SIZE.SM &&
          !isLockedEnterprise &&
          checkPermissionCreateContract()
        " class="btn mr-3" (click)="onUpdate()">
        <mat-icon class="mr-0">edit</mat-icon>
        {{ "enterprise_contract.buttons.edit" | translate }}
      </button>
      <button mat-raised-button color="primary" *ngIf="isStartSignFlow && !isLockedEnterprise && checkPermissionCreateContract()" class="btn mr-3"
              (click)="handleStartSignFlow()">
        <mat-icon class="mr-0">send</mat-icon>
        {{ "enterprise_contract.buttons.start_flow" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="btn mr-3" (click)="openDialogRefuseApprovalDocument()" appTrackEvent="w.btn.xem_chi_tiet_hd.tu_choi_phe_duyet"
              *ngIf="isApproveDocument">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ "enterprise_contract.buttons.reject" | translate }}
      </button>

      <!--Tu choi nld-->
      <button mat-stroked-button color="primary" class="btn mr-3" *ngIf="isEmploymentConfirmed == false && goFrom == 'waitSignMoha'" (click)="openDialogRefuseDocument()" appTrackEvent="w.btn.xem_chi_tiet_hd.tu_choi">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ "enterprise_contract.buttons.reject" | translate }}
      </button>

      <!--Chap nhan nld-->
      <button mat-raised-button color="primary" class="btn mr-3" *ngIf="isEmploymentConfirmed == false && goFrom == 'waitSignMoha'" (click)="acceptDocument()" appTrackEvent="w.btn.xem_chi_tiet_hd.chap_nhan">
        <mat-icon class="mr-0">check</mat-icon>
        {{ "confirm" | translate }}
      </button>

      <button mat-raised-button color="primary" class="btn mr-3" (click)="handleOpenDialogApprovalDocument()" appTrackEvent="w.btn.xem_chi_tiet_hd.duyet"
              *ngIf="isApproveDocument">
        <mat-icon class="mr-0">edit</mat-icon>
        {{ "enterprise_contract.buttons.approve" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="btn mr-3" (click)="openDialogRefuseSignDocument()"  appTrackEvent="w.btn.xem_chi_tiet_hd.tu_choi_ky_duyet"
              *ngIf="isSignDocument && checkEdit">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ "enterprise_contract.buttons.reject" | translate }}
      </button>
      <button mat-raised-button color="primary" class="btn mr-3" [disabled]="disableSign" (click)="handleSignPage()" *ngIf="isSignDocument && checkEdit" appTrackEvent="w.btn.xem_chi_tiet_hd.ky">
        <mat-icon class="mr-0">gesture</mat-icon>
        {{ "enterprise_contract.buttons.sign" | translate }}
      </button>
      <!-- <button mat-stroked-button color="primary" class="btn mr-3" (click)="openDialogInitial()" appTrackEvent="w.btn.xem_chi_tiet_hd.chuyen_ky_nhay"
              *ngIf="isForwarDocument">
        <mat-icon class="mr-0">send</mat-icon>
        {{ "enterprise_contract.buttons.forward_initial" | translate }}
      </button> -->
      <button mat-stroked-button color="primary" class="btn mr-3" (click)="openDialogDeclineInitialSign()" appTrackEvent="w.btn.xem_chi_tiet_hd.tu_choi_ky_nhay"
              *ngIf="isInitialDocument">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ "enterprise_contract.buttons.reject_inital" | translate }}
      </button>
      <button mat-raised-button color="primary" class="btn mr-3" (click)="openDialogInitialSign()" appTrackEvent="w.btn.xem_chi_tiet_hd.ky_nhay"
              *ngIf="isInitialDocument">
        <mat-icon class="mr-0">gesture</mat-icon>
        {{ "enterprise_contract.buttons.initial" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="btn mr-3" (click)="openDialogCancelSignFlow(document.id)" appTrackEvent="w.btn.xem_chi_tiet_hd.huy_luong_ky"
              *ngIf="isCancelDocument">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{ "enterprise_contract.buttons.cancel_flow" | translate }}
      </button>
      <button mat-raised-button color="primary" class="btn mr-3" (click)="retry()" *ngIf="cecaReTry && isShowRetry">
        <mat-icon class="mr-0">replay</mat-icon>
        {{ "enterprise_contract.buttons.retry" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="btn mr-3" (click)="signConfirmation()"
              *ngIf="isNotAttestedUser && document.status === EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && (!document.userApproves || document.userApproves.length == 0 || !isHasUserSignApprove) && isContractCreator">
        <mat-icon class="mr-0">gesture</mat-icon>
        {{ "enterprise_contract.buttons.signature_process" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="btn mr-3" (click)="openDialogCancelSignConfirmation()"
              *ngIf="isNotAttestedUser && document.status === EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && isHasUserSignApprove && isContractCreator">
        <mat-icon class="mr-0">cancel_presentation</mat-icon>
        {{ "enterprise_contract.buttons.cancel_signature_process" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="btn mr-3" (click)="reSignConfirmation()"
              *ngIf="isNotAttestedUser && document.status === EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && isHasUserSignApprove && isContractCreator">
        <mat-icon class="mr-0">gesture</mat-icon>
        {{ "enterprise_contract.buttons.reassign_signature_process" | translate }}
      </button>
      <button mat-stroked-button color="primary" class="btn mr-3" (click)="goToSignConfirmation()"
              *ngIf="checkShowSignConfirmBtn()">
        <mat-icon class="mr-0">gesture</mat-icon>
        {{ "enterprise_contract.buttons.sign_confirm" | translate }}
      </button>
      <button mat-raised-button *ngIf="isShowBtnReport || goFrom == 'waitSignMoha'" (click)="openViewProperties()" class="btn" color="primary">
        {{ "add_document_moha.labor_contract_report_information" | translate }}
      </button>
    </div>

    <div class="scontract-btn-mobile bg-white text-center shadow-lg rounded">
      <ngx-slick-carousel #btnView class="carousel" #slickModal="slick-carousel" [config]="slideButtonConfig">
        <div ngxSlickItem class="flex-fill slide" (click)="onBackClick()" appTrackEvent="w.btn.xem_chi_tiet_hd.quay_lai">
          <mat-icon>arrow_back</mat-icon>
          <h6 class="mb-0">{{ "form.back" | translate }}</h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="tongleFullviewPdf()">
          <mat-icon *ngIf="!isFullviewPdf">fullscreen</mat-icon>
          <mat-icon *ngIf="isFullviewPdf">info</mat-icon>
          <h6 class="mb-0" *ngIf="isFullviewPdf">{{ 'enterprise_contract.tooltips.info_tab' | translate }}</h6>
          <h6 class="mb-0" *ngIf="!isFullviewPdf">{{ 'enterprise_contract.tooltips.view_document' | translate }}</h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="onUpdate()" *ngIf="
            isStartSignFlow &&
            mediaBreakpoint !== SCREEN_SIZE.XS &&
            mediaBreakpoint !== SCREEN_SIZE.SM &&
            !isLockedEnterprise &&
            checkPermissionCreateContract()
          ">
          <mat-icon>edit</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.edit" | translate }}
          </h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="handleStartSignFlow()"
             *ngIf="isStartSignFlow && !isLockedEnterprise && checkPermissionCreateContract()">
          <mat-icon>send</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.start_flow" | translate }}
          </h6>
        </div>

        <!--Tu choi Phe duyet-->
        <div ngxSlickItem class="flex-fill slide" (click)="openDialogRefuseApprovalDocument()" appTrackEvent="w.btn.xem_chi_tiet_hd.tu_choi_phe_duyet"
             *ngIf="isApproveDocument">
          <mat-icon>cancel</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.reject" | translate }}
          </h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="handleOpenDialogApprovalDocument()" *ngIf="isApproveDocument" appTrackEvent="w.btn.xem_chi_tiet_hd.duyet">
          <mat-icon>gesture</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.approve" | translate }}
          </h6>
        </div>
        <!--Tu choi NLD-->
        <div ngxSlickItem class="flex-fill slide" (click)="openDialogRefuseDocument()" *ngIf="goFrom == 'waitSignMoha'" appTrackEvent="w.btn.xem_chi_tiet_hd.tu_choi">
          <mat-icon>cancel</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.reject" | translate }}
          </h6>
        </div>

        <!--Tu choi Ky duyet-->
        <div ngxSlickItem class="flex-fill slide" (click)="openDialogRefuseSignDocument()" *ngIf="isSignDocument" appTrackEvent="w.btn.xem_chi_tiet_hd.tu_choi_ky_duyet">
          <mat-icon>cancel</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.reject" | translate }}
          </h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="handleSignPage()" *ngIf="isSignDocument" appTrackEvent="w.btn.xem_chi_tiet_hd.ky">
          <mat-icon>gesture</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.sign" | translate }}
          </h6>
        </div>
        <!-- <div ngxSlickItem class="flex-fill slide" (click)="openDialogInitial()" *ngIf="isForwarDocument" appTrackEvent="w.btn.xem_chi_tiet_hd.chuyen_ky_nhay">
          <mat-icon>gesture</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.forward_initial" | translate }}
          </h6>
        </div> -->
        <div ngxSlickItem class="flex-fill slide" (click)="openDialogDeclineInitialSign()" *ngIf="isInitialDocument" appTrackEvent="w.btn.xem_chi_tiet_hd.tu_choi_ky_nhay">
          <mat-icon>cancel</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.reject_inital" | translate }}
          </h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="openDialogInitialSign()" *ngIf="isInitialDocument" appTrackEvent="w.btn.xem_chi_tiet_hd.ky_nhay">
          <mat-icon>gesture</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.initial" | translate }}
          </h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="openDialogCancelSignFlow(document.id)" appTrackEvent="w.btn.xem_chi_tiet_hd.huy_luong_ky"
             *ngIf="isCancelDocument">
          <mat-icon>cancel</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.cancel_flow" | translate }}
          </h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="signConfirmation()"
             *ngIf="isNotAttestedUser && document.status === EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && (!document.userApproves || document.userApproves.length == 0 || !isHasUserSignApprove) && isContractCreator">
          <mat-icon>gesture</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.signature_process" | translate }}
          </h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="openDialogCancelSignConfirmation()"
             *ngIf="isNotAttestedUser && document.status === EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && isHasUserSignApprove && isContractCreator">
          <mat-icon>cancel_presentation</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.cancel_signature_process" | translate }}
          </h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="reSignConfirmation()"
             *ngIf="isNotAttestedUser && document.status === EnumContractStatus.WAIT_CONFIRM_ENTERPRISE_NO_MOIT && isHasUserSignApprove && isContractCreator">
          <mat-icon>gesture</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.reassign_signature_process" | translate }}
          </h6>
        </div>
        <div ngxSlickItem class="flex-fill slide" (click)="goToSignConfirmation()"
             *ngIf="checkShowSignConfirmBtn()">
          <mat-icon>gesture</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.sign_confirm" | translate }}
          </h6>
        </div>
        <!-- <div
          ngxSlickItem
          class="flex-fill slide"
          (click)="gotoSignPage()"
          *ngIf="isGotoSignPageDocument"
        >
          <mat-icon>pin_drop</mat-icon>
          <h6 class="mb-0">
            {{ "enterprise_contract.buttons.goto_signing_page" | translate }}
          </h6>
        </div> -->
      </ngx-slick-carousel>
    </div>
  </div>

</div>

<mat-card *ngIf="!isCheckAccessToContract && !checkStatusProgress">
  <mat-card-content class="mb-3">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" style="height: calc(100vh - 104px)">
        <div class="container">
          <div class="row" style="padding-top: 50px">
            <div class="col-11 offset-1 text-center">
              <h4>{{ "alert.page_not_found_no_access" | translate }}</h4>
              <h4>
                {{ "alert.back_home_no_access" | translate }}
              </h4>
              <button mat-stroked-button color="primary" type="button" (click)="goBack()">
                <mat-icon class="mr-0">arrow_back</mat-icon>
                {{ "alert.back_history" | translate }}
              </button>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-card-content>
</mat-card>


<div class="document scrollbar_scontract_xs" *ngIf="checkStatusProgress" >
  <app-preview-contract-document-view-moha (changePrintf)="doPrint()" [idDocument]="id" [senderName]="senderName" [nameOrEmailOrPhoneUserSign]="nameOrEmailOrPhoneUserSign" [signRole]="signRole" [receivedTimeTo]="receivedTimeTo" [receivedTimeFrom]="receivedTimeFrom" [MY_DOCUMENT_ROUTER_ON_BACK_LINK]="DEFAULT_RECEIVER_ROUTER_ON_BACK_LINK"  [selectForm]="true" [maxSize]="10485760" [documentTypeEnterprise]="documentTypeEnterprise" ></app-preview-contract-document-view-moha>
</div>


